// SPDX-FileCopyrightText: 2022-2026 Lablup Inc. All rights reserved.
// SPDX-License-Identifier: LicenseRef-Proprietary
import { createStore } from "jotai";

/**
 * The single Jotai store used by the app. `index.tsx` passes this to
 * `<Provider store={jotaiStore}>` so React hooks (`useAtomValue`,
 * `useSetAtom`) read/write through it, and non-React code (e.g.
 * `fetchCurrentUser`) imports it directly instead of reaching for
 * `getDefaultStore()`.
 *
 * Why this exists: `<Provider>` without an explicit store creates its own
 * isolated store per mount, which is *not* the same as `getDefaultStore()`.
 * Writing via `getDefaultStore().set(...)` from outside React while reading
 * via `useAtomValue` from inside the provider silently diverges — the
 * consumer never observes the write. See issue #3382.
 */
export const jotaiStore = createStore();
